import { render, staticRenderFns } from "./AddFundForm.vue?vue&type=template&id=c22ea22a&"
import script from "./AddFundForm.vue?vue&type=script&lang=ts&"
export * from "./AddFundForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddFundForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports